// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Inner_sidebar_2orUO","section":"Inner_section_29Xf0","title":"Inner_title_39ARo","documents":"Inner_documents_2quyn","_active":"Inner__active_3IwV4"};